import React, { Component } from 'react';
import classNames from 'classnames';
import { ServiceLogin } from "./service/Login";

export class AppInlineProfile extends Component {

    constructor() {
        super();
        this.state = {
            expanded: false
        };
        this.onClick = this.onClick.bind(this);
    }

    onClick(event) {
        this.setState({expanded: !this.state.expanded});
        event.preventDefault();
    }

    render() {
        return  (
            <div className="profile">
                <div>
                    <img src={`assets/layout/images/${ServiceLogin.getUserSex()}.png`} alt="" />
                </div>
                <a className="profile-link" onClick={this.onClick}>
                    <span className="username">{ServiceLogin.getUserName()}</span>
                    <i className="pi pi-fw pi-cog"/>
                </a>
                <ul className={classNames({'profile-expanded': this.state.expanded})}>
                    <li onClick={()=>window.location = "#/logout"}><a><i className="pi pi-fw pi-power-off"/><span>Logout</span></a></li>
                </ul>
            </div>
        );
    }
}